import axios from 'axios'
import router from '../router'
import { isEqual, cloneDeep } from 'lodash'
import moment from 'moment'
import swal from 'sweetalert'
import { prepareFacilityOptions } from '../helpers.js'

axios.defaults.headers.common['X-CSRF-TOKEN'] = Laravel.csrfToken
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/* Startup the app */
export const init = async function(store) {
  console.log('Initializing...')
  await store.dispatch('fetchAppConfig')

  try {
    await store.dispatch('setUser')
  } catch (error) {
    // Authentication not required to use this app.
    console.log('Not authenticated')
  }

  // Load a saved pricing request via "uiid" URL query param (user_inputs id)
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('uiid')) {
    await store.dispatch('loadPriceRequestByUiid', urlParams.get('uiid'))
  }

  console.log('Initialized')
  return true
}

/* Fetch App Config Data */
export const fetchAppConfig = async function({ commit }) {
  console.log('Fetching Pricing Calculator config...')
  const response = await axios.get('/pricing-calculator/config')
  commit('SET_APP_CONFIG', response.data)
}

/* Set User Data */
export const setUser = async function({ commit }) {
  console.log('Getting user...')
  const response = await axios.get('/pricing-calculator/me')
  commit('SET_USER', response.data)
  commit('SET_REGISTERED')

  if (response.data.userBranding) {
    commit('SET_USER_BRANDING', response.data.userBranding)
  }
}

/* Set User Preferences */
export const setUserPreferences = function({ commit }, data) { 
  commit('SET_USER_PREFERENCES', data)
}

/* Set Application View */
export const setView = function(store, view) {
  switch(view) {
    case 'workspace':
      store.commit('SET_VIEW_WORKSPACE')

      if (Object.keys(store.state.currentPricingData.data).length) {
        router.push({ name: 'PricingData' })
      } else {
        router.push({ name: 'GetPricing' })
      }
      
      break
    case 'dashboard-warn':
      if (store.state.currentPricingRequest.utility.id) {
        // if (store.state.pricingRequestStatus.length && store.state.pricingRequestStatus !== 'DataCompleted' && store.state.pricingRequestStatus !== 'Loaded') {

        console.log('setView.dashboard-warn')
        const swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will clear any unsaved changes, are you sure you want to leave?</p>'

        swal({
          content: swalContent,
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "",
              closeModal: true,
            },
            confirm: {
              text: "Yes",
              value: true,
              visible: true,
              className: "",
              closeModal: true,
            }
          }
        }).then(result => {
          if (result) {
            store.commit('SET_VIEW_DASHBOARD')
            router.push({ name: 'PricingTable'})
            commit('CLEAR_CURRENT_PRICING_REQUEST')
            commit('CLEAR_CURRENT_PRICING_CHART_DATA')
            store.dispatch('clearAllFacilityData')
          }
        }).catch(error => {})

        return

      } else {
        store.commit('SET_VIEW_DASHBOARD')
        router.push({ name: 'PricingTable' })
      }

      // } 

      // store.commit('SET_VIEW_DASHBOARD')
      // router.push({ name: 'PricingTable' })
      break
    case 'dashboard':
      store.commit('SET_VIEW_DASHBOARD')
      router.push({ name: 'PricingTable' })
      break
    default:
      store.commit('SET_VIEW_WORKSPACE')
      router.push({ name: 'GetPricing' })
  }
}

/* Set Store View Only */
export const setStoreView = function(store, view) {
  switch(view) {
    case 'workspace':
      store.commit('SET_VIEW_WORKSPACE')

      // if (Object.keys(store.state.currentPricingData.data).length) {
      //   router.push({ name: 'PricingData' })
      // } else {
      //   router.push({ name: 'GetPricing' })
      // }
      
      break
    case 'dashboard-warn':
      if (store.state.currentPricingRequest.utility.id) {
      // if (store.state.pricingRequestStatus.length && store.state.pricingRequestStatus !== 'DataCompleted' && store.state.pricingRequestStatus !== 'Loaded') {

        console.log('setStoreView.dashboard-warn')
        const swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will clear any unsaved changes, are you sure you want to leave?</p>'

        swal({
            content: swalContent,
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                className: "",
                closeModal: true,
              },
              confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true,
              }
            }
          }).then((result) => {
            if (result) {
              store.commit('SET_VIEW_DASHBOARD')
              //router.push({ name: 'PricingTable' })
              commit('CLEAR_CURRENT_PRICING_REQUEST')
              commit('CLEAR_CURRENT_PRICING_CHART_DATA')
              store.dispatch('clearAllFacilityData')
            }
          }).catch(error => {})

        return
      } else {
        store.commit('SET_VIEW_DASHBOARD')
       // router.push({ name: 'PricingTable' })
      }

      // }

      // store.commit('SET_VIEW_DASHBOARD')
      // router.push({ name: 'PricingTable' })
      break
    case 'dashboard':
      store.commit('SET_VIEW_DASHBOARD')
      // router.push({ name: 'PricingTable' })
      break
    default:
      store.commit('SET_VIEW_WORKSPACE')
      // router.push({ name: 'GetPricing' })
  }
}

/* Set Notification Message */
export const setNotification = function({ commit }, data) {
  let title = ''
  if (data.title) {
    title = data.title
  }

  commit('SET_NOTIFICATION', { 
    type: data.type,
    title: title,
    msg: data.msg,
  })

  window.setTimeout(() => {
    commit('CLEAR_NOTIFICATION')
  }, 100)
}

/* Clear Notification Message */
export const clearNotification = function({ commit }) {
  commit('CLEAR_NOTIFICATION')
}

/* Set Concurrent Session Alert */
export const setConcurrentSessionAlert = function({ commit }, data) {
  const swalContent = document.createElement('div')
  swalContent.innerHTML = '<p class="alerts message alerts--no-brdr mrgn-btm-5">' + data.msg + '</p>'

  swal({
    title: '<span class="alerts alerts--no-brdr">Logout Warning</span>',
    content: swalContent,
    closeOnEsc: false,
    closeOnClickOutside: false,
    buttons: {
      confirm: {
        text: "OK",
        value: true,
        visible: true,
        className: "",
        closeModal: true,
      }
    }
  }).then(result => {
    window.location = '/'
  })
}

/* Set Utility */
export const setUtility = function(store, utilityData) {
  store.commit('SET_UTILITY', utilityData)

  axios.get('/pricing-calculator/utilities/' + utilityData.id + '/pricing-components')
    .then(response => {
      store.commit('SET_PRIMARY_PRICING_COMPONENT', response.data[0])
    })

  store.dispatch('clearAllFacilityData')
  store.dispatch('fetchFacilityProfiles', utilityData.id)
  store.dispatch('resetCustomFacilityProfileUiStep')

  router.push({ name: 'StartMonth' })
}

/* Set Application View */
export const setPlanConfig = function({ commit }, planConfig) {
  commit('SET_PLAN_CONFIG', planConfig)
}

/* Set Utility via Zip Entry */
export const setUtilityByZip = function(store, payload) { 
  axios.post('/pricing-calculator/utilities/search', { 
    zip: payload.zip,
    utility_id: payload.utilityId || null
  })
    .then(response => {
      let utilityData = {
        id: response.data.id,
        code: payload.zip,
        name: response.data.name, 
        state: response.data.state,
        municipality: response.data.municipality,
        zone: response.data.zone,
        displayBrokerFee: response.data.display_broker_fee,
        planData: {
          id: response.data.id,
          name: response.data.name,
          plan: {
            name: store.state.currentPricingRequest.utility.plan.name,
            slug: store.state.currentPricingRequest.utility.plan.slug,
          },
        },
      }

      let oldPlan = store.state.currentPricingRequest.utility.plan.slug

      // Authenticated user?
      if (store.state.auth.user.id) {

        // Check plan level utility is subscribed at
        axios.get('/pricing-calculator/me/utilities/' + response.data.id + '/get-plan')
          .then(response => {
            utilityData.planData.plan = {
              name: response.data.name,
              slug: response.data.slug
            }

            store.dispatch('clearCurrentPricingRequest')
            store.dispatch('clearAllFacilityData')

            setTimeout(() => {
              store.dispatch('setUtility', utilityData)
            }, 10)
          })
          .catch(error => {})

      } else {
        store.dispatch('setUtility', utilityData)
      }
    })
    .catch(error => {

      // Show an alert if a concurrent session is detected.
      if (error.response.status == 401 && error.response.data.errorCode == 'concurrent-session') {
        store.dispatch('setConcurrentSessionAlert', {
          msg: error.response.data.error
        })
        return false
      }

      // Show an alert if the selected zip code is not 
      // associated with the selected utility.
      if (error.response.data.errorMsg) {
        store.dispatch('setNotification', {
          type: 'error',
          msg: error.response.data.errorMsg
        })
        return false
      }
      
      store.dispatch('setNotification', {
        type: 'error',
        msg: 'No utilities found for that zip code.'
      })
    })
}

/* Submit Utility Votes / EPB Coming Soon Interest Inquiry */
export const submitUtilityVotes = function({ commit }, data) {
  //console.log(data.votes.comingSoon)
  //console.log(data.votes.other)
  //console.log(data.inquiry)

  let utilityIds = data.votes.comingSoon
    .concat(data.votes.other)
    .map(utility => {
      return utility.id
    })
    .filter(id => {
      return null != id
    })

  axios.post('/pricing-calculator/interest', { 
    utilities: utilityIds,
    inquiry: data.inquiry,
  })
    .then(response => {
      // Success
    })
    .catch(error => {
      commit.store.dispatch('setNotification', {
        type: 'error',
        msg: 'An unknown error occurred.'
      })
    })
}

/* Fetch Custom Facility Profiles Columns */
export const fetchCustomFacilityProfileColumns = function({ commit }, utilityId) {
  axios.get('/pricing-calculator/utilities/' + utilityId + '/custom-facility-profile-rows')
    .then(response => {
      commit('SET_CUSTOM_FACILITY_PROFILE_COLUMNS', response.data)
    })
}

/* Clear Custom Facility Profiles Columns */
export const clearCustomFacilityProfileColumns = function({ commit }) {
  commit('CLEAR_CUSTOM_FACILITY_PROFILE_COLUMNS')
}

/* Fetch Facility Profiles */
export const fetchFacilityProfiles = function(store, utilityId) {

  // Only fetch the facility profiles if they're not same as what's 
  // already been loaded.
  if (utilityId === store.state.facilityProfilesUtilityId) {
    return
  }

  store.commit('SET_FACILITY_PROFILES_UTILITY_ID', utilityId)

  axios.get('/pricing-calculator/facility-profiles/' + utilityId)
    .then(response => {
      store.commit('SET_FACILITY_PROFILES', response.data)
    })
}

/* Clear Facility Profiles */
export const clearFacilityProfiles = function({ commit }) {
  commit('CLEAR_FACILITY_PROFILES')
}

/* Set Facility Category */
export const setFacilityCategory = function({ commit }, data) {  
  let checkboxOptions = 0

  if (data.checkboxOptions) {
    checkboxOptions = data.checkboxOptions
  }

  if (! data.preventVolumeReset) {
    commit('RESET_STATE_BROKER_FEE')
    commit('CLEAR_CUSTOM_FACILITY_VOLUME')
    commit('CLEAR_VOLUME')
  }

  commit('SET_FACILITY_CATEGORY', { 
    id: data.id,
    name: data.name,
    thumb: data.thumb,
    options: data.options,
    parents: data.parents,
    twoColumns: data.twoColumns,
    checkboxOptions: checkboxOptions
  })
}

/* Set Inline Facility Path */
export const setInlineFacilityPath = function({ commit }, path) {
  commit('SET_INLINE_FACILITY_PATH', path)
}

/* Clear Inline Facility Path */
export const clearInlineFacilityPath = function({ commit }) {
  commit('CLEAR_INLINE_FACILITY_PATH')
}

/* Clear Facility Category */
export const clearFacilityCategory = function({ commit }) {
  commit('CLEAR_FACILITY_CATEGORY')
}

/* Set Facility Type */
export const setFacilityType = function({ commit }, data) {
  commit('RESET_STATE_BROKER_FEE')
  commit('CLEAR_CUSTOM_FACILITY_VOLUME')
  commit('CLEAR_VOLUME')

  commit('SET_FACILITY_TYPE', { 
    id: data.id,
    name: data.name,
    category: data.category,
    parents: data.parents,
    displayName: data.displayName
  })

  commit('CLEAR_CUSTOM_FACILITY_PROFILE')
  commit('CLEAR_TEMP_CUSTOM_FACILITY_PROFILE')
  commit('CLEAR_FACILITY_PROFILE_NAME')
  commit('CLEAR_CUSTOM_FACILITY_PROFILE_CATEGORY')
  commit('UNSET_CUSTOM_FACILITY_PROFILE_VIEW')
  commit('CLEAR_FACILITY_CHECKBOX_SELECTIONS') 
  commit('EXPAND_CUSTOM_FACILITY_PROFILE_TABLE') 
}

/* Set User-Defined Facility Profile Name */
export const setFacilityProfileName = function({ commit }, name) {
  commit('SET_FACILITY_PROFILE_NAME', name)
}

/* Set User-Defined Custom Facility Profile Category */
export const setCustomFacilityProfileCategory = function(store, category) {
  store.commit('SET_CUSTOM_FACILITY_PROFILE_CATEGORY', {
    tier1: {
      id: category.tier1.id,
      name: category.tier1.name,
      displayName: category.tier1.displayName,
      index: category.tier1.index
    },
    tier2: Object.assign({}, category.tier2)
  })

  let utility = store.state.currentPricingRequest.utilityMeta
  let facilityProfileOptions = prepareFacilityOptions(category.tier2.facilityType, category.tier2.facilityCheckboxOptions)

  // Return a promise so we can do stuff after the custom facility profile category 
  // data is loaded...
  return new Promise((resolve, reject) => {
    axios.post('/pricing-calculator/facility-profiles/' + utility.id + '/profile/' + category.tier1.id + '/data', {
      facility_profile_id: category.tier1.id,
      facility_profile_options: facilityProfileOptions
    })
      .then(response => {
        store.commit('SET_CUSTOM_FACILITY_PROFILE_CATEGORY_DATA', response.data)
        resolve()
      })
      .catch(error => {
        store.dispatch('setNotification', {
          type: 'error',
        })
        reject()
      })
  })
}

/* Set Facility Suboptions */
export const setFacilityCheckboxSelections = function({ commit }, data) {
  commit('RESET_STATE_BROKER_FEE')
  commit('CLEAR_CUSTOM_FACILITY_VOLUME')
  commit('CLEAR_VOLUME')
  commit('SET_FACILITY_CHECKBOX_SELECTIONS', data)
}

/* Clear Facility Suboptions */
export const clearFacilityCheckboxSelections = function({ commit }) {
  commit('CLEAR_FACILITY_CHECKBOX_SELECTIONS')  
}

/* Set Custom Facility Profile */
export const setCustomFacilityProfile = function({ commit }, data) {
  commit('CLEAR_VOLUME')

  commit('SET_FACILITY_TYPE', { 
    id: null,
    name: "Custom Facility Profile",
    category: null,
    parents: null,
    displayName: null
  })

  commit('CLEAR_FACILITY_CHECKBOX_SELECTIONS')
  commit('SET_CUSTOM_FACILITY_PROFILE_VIEW')
  commit('SET_CUSTOM_FACILITY_PROFILE', data)
}

/* Set Custom Facility Profile */
export const setTempCustomFacilityProfile = function({ commit }, data) {
  commit('CLEAR_FACILITY_CHECKBOX_SELECTIONS')
  commit('SET_CUSTOM_FACILITY_PROFILE_VIEW')
  commit('SET_TEMP_CUSTOM_FACILITY_PROFILE', data)
}

/* Clear Custom Facility Profile */
export const clearTempCustomFacilityProfile = function({ commit }) {
  commit('CLEAR_TEMP_CUSTOM_FACILITY_PROFILE')
}

/* Set the Current Custom Facility Profile UI Step/View */
export const setCustomFacilityProfileUiStep = function({ commit }, step) {
  commit('SET_CUSTOM_FACILITY_PROFILE_UI_STEP', step)
}

/* Reset the Current Custom Facility Profile UI Step/View */
export const resetCustomFacilityProfileUiStep = function({ commit }) {
  commit('SET_CUSTOM_FACILITY_PROFILE_UI_STEP', 'meta')
}

/* Set Custom Facility Profile View */
export const setCustomFacilityProfileView = function({ commit }) {
  commit('SET_CUSTOM_FACILITY_PROFILE_VIEW')
}

/* Unset Custom Facility Profile View */
export const unsetCustomFacilityProfileView = function({ commit }) {
  commit('UNSET_CUSTOM_FACILITY_PROFILE_VIEW')
}

/* Set the Current Custom Facility Profile UI On-Peak Percent Choice */
export const setCustomFacilityProfileUiOnPeakUsagePercentChoice = function({ commit }, value) {
  commit('SET_CUSTOM_FACILITY_PROFILE_UI_ON_PEAK_USAGE_PERCENT_CHOICE', value)
}

/* Set the Current Custom Facility Profile UI Repeat Monthly Values Choice */
export const setCustomFacilityProfileUiRepeatMonthlyValues = function({ commit }, value) {
  commit('SET_CUSTOM_FACILITY_PROFILE_UI_REPEAT_MONTHLY_VALUES', value)
}

/* Set that the user has changed a default Current Custom Facility Profile On-Peak Usage (%) value  */
export const setUserHasChangedACustomFacilityProfileOnPeakUsagePercentValue = function({ commit }, value) {
  commit('SET_USER_HAS_CHANGED_A_CUSTOM_FACILITY_PROFILE_ON_PEAK_USAGE_PERCENT_VALUE', value)
}

/* Collapse Custom Facility Profile Table */
export const collapseCustomFacilityProfileTable = function({ commit }) {
  commit('COLLAPSE_CUSTOM_FACILITY_PROFILE_TABLE')
}

/* Expand Custom Facility Profile Table */
export const expandCustomFacilityProfileTable = function({ commit }) {
  commit('EXPAND_CUSTOM_FACILITY_PROFILE_TABLE')
}

/* Clear Custom Facility Profile */
export const clearCustomFacilityProfile = function({ commit }, data) {
  commit('CLEAR_CUSTOM_FACILITY_PROFILE')
  commit('CLEAR_FACILITY_TYPE')
  commit('UNSET_CUSTOM_FACILITY_PROFILE_VIEW')
  // commit('CLEAR_FACILITY_PROFILE_NAME')
  // commit('CLEAR_CUSTOM_FACILITY_PROFILE_CATEGORY')
  commit('CLEAR_CUSTOM_FACILITY_VOLUME')
  commit('CLEAR_VOLUME')
}

/* Reset All Facility Options and Data */
export const clearAllFacilityData = function({ commit }) {
  commit('CLEAR_FACILITY_CHECKBOX_SELECTIONS')
  commit('CLEAR_CUSTOM_FACILITY_PROFILE')
  commit('CLEAR_TEMP_CUSTOM_FACILITY_PROFILE')
  commit('CLEAR_FACILITY_TYPE')
  commit('CLEAR_FACILITY_PROFILE_NAME')
  commit('CLEAR_CUSTOM_FACILITY_PROFILE_CATEGORY')
  commit('CLEAR_FACILITY_PROFILES')
  commit('CLEAR_CUSTOM_FACILITY_PROFILE_COLUMNS')
  commit('UNSET_CUSTOM_FACILITY_PROFILE_VIEW')
}

/* Set Volume */
export const setVolume = function({ commit }, data) {
  commit('SET_VOLUME', { 
    amount: data.amount,
    unit: data.unit,
    brokerFee: data.brokerFee,
    adjustmentNotes: data.adjustmentNotes,
    displayAdjustmentInNav: data.displayAdjustmentInNav,
  })
}

/* Clear Volume */
export const clearVolume = function({ commit }) {
  commit('CLEAR_VOLUME')
}

/* Reset State Broker Fee */
export const resetStateBrokerFee = function({ commit }) {
  commit('RESET_STATE_BROKER_FEE')
}

/* Set Custom Facility Volume */
export const setCustomFacilityVolume = function({ commit }, data) {
  commit('SET_CUSTOM_FACILITY_VOLUME', { 
    terms: data.terms,
    brokerFee: data.brokerFee,
    adjustmentNotes: data.adjustmentNotes,
    displayAdjustmentInNav: data.displayAdjustmentInNav,
  })
}

/* Clear Custom Facility Volume */
export const clearCustomFacilityVolume = function({ commit }) {
  commit('CLEAR_CUSTOM_FACILITY_VOLUME')
}

/* Decline Broker Fee */
export const declineBrokerFee = function({ commit }) {
  commit('DECLINE_BROKER_FEE')
}

/* Allow Broker Fee */
export const allowBrokerFee = function({ commit }) {
  commit('ALLOW_BROKER_FEE')
}

/* Restrict Broker Fee */
export const restrictBrokerFee = function({ commit }) {
  commit('RESTRICT_BROKER_FEE')
}

/* Set Start Month */
export const setStartMonth = function({ commit }, timestamp) {
  commit('CLEAR_TERM_LENGTH')
  commit('SET_START_MONTH', timestamp)
  commit('RESET_STATE_BROKER_FEE')
  commit('CLEAR_VOLUME')
  router.push({ name: 'TermLength' })
}

/* Clear Start Month */
export const clearStartMonth = function({ commit }) {
  commit('CLEAR_START_MONTH')
}

/* Set Term Length */
export const setTermLength = function({ commit }, data) {
  commit('RESET_STATE_BROKER_FEE')
  // commit('CLEAR_VOLUME') // DO NOT DO... this clears the volume when loading a price request via
                            // the Dashboard if the currently-selected utility plan does not match
                            // the utility plan of the just-selected price request, and it shouldn't.
                            // Triggered by app/components/Utility-Watcher::manageTermLengths()
  commit('SET_TERM_LENGTH', data)
}

/* Clear Term Length */
export const clearTermLength = function({ commit }) {
  const obj = [
    {
      id: 1,
      value: ''
    },
    {
      id: 2,
      value: ''
    },
    {
      id: 3,
      value: ''
    }
  ]

  commit('SET_TERM_LENGTH', obj)
}

/* Clear Current Pricing Request */
export const clearCurrentPricingRequest = function({ commit }) {
  commit('CLEAR_CURRENT_PRICING_REQUEST')
  commit('CLEAR_CURRENT_PRICING_CHART_DATA')

  if (router.currentRoute.name != 'Utility') {
    router.push({ name: 'Utility' })
  }
}

/* Enable Pricing Request Submission */
export const enablePricingRequestSubmission = function({ commit }) {
  commit('ENABLE_PRICING_REQUEST_SUBMISSION')
}

/* Disable Pricing Request Submission */
export const disablePricingRequestSubmission = function({ commit }) {
  commit('DISABLE_PRICING_REQUEST_SUBMISSION')
}

/* Hover On Pricing Request Submission Button */
export const hoverOnSubmitPricingRequest = function({ commit }) {
  commit('HOVER_ON_SUBMIT_PRICING_REQUEST')
}

/* Hover Off Pricing Request Submission Button */
export const hoverOffSubmitPricingRequest = function({ commit }) {
  commit('HOVER_OFF_SUBMIT_PRICING_REQUEST')
}

/* Save Pricing Request */
export const savecurrentPricingRequest = function(store, issueImmediately) {
  const utility = store.state.currentPricingRequest.utilityMeta
  const utilityPlanData = store.state.currentPricingRequest.utility
  const subscribedPricingRequestIds = store.getters.savedPricingRequestIds?.subscribed || []
  const unsubscribedPricingRequestIds = store.getters.savedPricingRequestIds?.unsubscribed || []
  const skipRedirect = issueImmediately

  if (utilityPlanData.plan.slug === 'free-registered' && unsubscribedPricingRequestIds.length) {

    // If the inputs have been edited since last loaded
    if (!isEqual(store.state.currentPricingRequest, store.state.lastLoadedPricingRequest)) {

      const swalContent = document.createElement('div')
      swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will save one or more changes to your current set of saved inputs. Do you want to continue?</p>'

      swal({
        content: swalContent,
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: "Cancel",
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "",
            closeModal: true,
          }
        }
      }).then((result) => {
        if (result) {
          store.dispatch('updatesavedPricingRequest', skipRedirect)
        }
      }).catch(error => {})

      return
    }

    store.dispatch('updatesavedPricingRequest', skipRedirect)

    return
  }
    
  if (utilityPlanData.plan.slug === 'basic' && subscribedPricingRequestIds.length >= store.state.planConfig.priceRequestSlots) {

    const swalContent = document.createElement('div')
    swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">Saved price request limit reached. To save, eliminate a current request for this utility, or upgrade (all subscribed utilities) to Premium.</p>'

    swal({
      content: swalContent,
      closeOnEsc: false,
      closeOnClickOutside: false,
      reverseButtons: true,
      buttons: {
        cancel: {
          text: "OK",
          value: null,
          visible: true,
          className: "swal-button--cancel--blue",
          closeModal: true,
        },
        confirm: {
          text: "Upgrade",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        }
      }
    }).then((result) => {
      if (result) {
        savePricingRequest(store, true)

        setTimeout(() => {
          window.location.href = '/account/subscription?limit-reached-upgrade'
        }, 400)
      }
    })

    return
  }

  savePricingRequest(store, skipRedirect)

  /**
   * Save a pricing request.
   * 
   * @param  {Vuex}  store
   * @param  {Boolean}  skipRedirect
   * @return {undefined}
   */
  function savePricingRequest(store, skipRedirect) {

    // Copy the existing pricing request
    let pricingRequest = cloneDeep(store.state.currentPricingRequest)

    // Convert Start Date Format
    if (pricingRequest.startMonth) {
      pricingRequest.startMonth = moment(pricingRequest.startMonth).format('YYYY-MM-DD')
    }

    // Transform terms array
    if (pricingRequest.termLength) {
      pricingRequest.termLength = pricingRequest.termLength.filter(t => t.value != '').map(t => ({ term: t.value }))
    }

    if (pricingRequest.customFacilityProfile.total && pricingRequest.customFacilityProfile.total.usage) {
      
      pricingRequest.volume.declineBrokerFee = store.state.declineBrokerFee
      pricingRequest.volume.amount = pricingRequest.customFacilityProfile.total.usage
    }

    // Determine facility type name
    pricingRequest.facilityTypeName = ''

    // Trace parent facility type name from ancestor options
    if (pricingRequest.facilityType.parents) {
      let facilityProfileId = pricingRequest.facilityType.id

      if (pricingRequest.facilityType.parents.length > 1) {
        facilityProfileId = pricingRequest.facilityType.parents[pricingRequest.facilityType.parents.length - 2]
      }  

      // Get a specific facility profile with utility-specific information.
      axios.get('/pricing-calculator/facility-profiles/' + pricingRequest.utilityMeta.id + '/profile/' + facilityProfileId)
        .then(facilityProfilesResponse => {
          pricingRequest.facilityTypeName = facilityProfilesResponse.data.name

          // Save a new set of user inputs.
          axios.post('/pricing-calculator/me/inputs/' + pricingRequest.utilityMeta.id, pricingRequest)
            .then(response => {
              store.dispatch('setDashboardSortUtility', pricingRequest.utilityMeta)
              localStorage.setItem('epb_utility_sort', JSON.stringify(pricingRequest.utilityMeta))
              localStorage.setItem('epb_uid', store.state.auth.user.id)

              if (!skipRedirect) {
                store.dispatch('clearCurrentPricingRequest')
                store.dispatch('clearAllFacilityData')
                router.push({ name: 'PricingTable'})
              }

              store.commit('SET_SAVED_PRICING_REQUEST_ID',  response.data.id)

              if (issueImmediately) {
                store.dispatch('getPricing', response.data.id)
                store.dispatch('fetchSavedPricingRequests')
              }
            })
            .catch(error => {

              // @note If we get here and EPB flags it as an issue, we likely just need to call
              //       store.dispatch('updatesavedPricingRequest', skipRedirect)
              //       as opposed to dispatching the notification below, in order to 
              //       replace the existing unsubscribed set of user inputs.
              console.error(error)
              store.dispatch('setNotification', {
                type: 'error',
                msg: (error.response && error.response.data) ? error.response.data : 'An unexpected error occurred.'
              })
            })
        })
        .catch(error => {
          store.dispatch('setNotification', {
            type: 'error',
          })
        })
    } else {
      if (pricingRequest.customFacilityProfileCategory.tier2 && pricingRequest.customFacilityProfileCategory.tier2.name) {
        pricingRequest.facilityTypeName = 'Custom: ' + pricingRequest.customFacilityProfileCategory.tier2.name
      }

      // Save a new set of user inputs.
      axios.post('/pricing-calculator/me/inputs/' + pricingRequest.utilityMeta.id, pricingRequest)
        .then(response => {
          store.dispatch('setDashboardSortUtility', pricingRequest.utilityMeta)
          localStorage.setItem('epb_utility_sort', JSON.stringify(pricingRequest.utilityMeta))
          localStorage.setItem('epb_uid', store.state.auth.user.id)

          if (!skipRedirect) {
            store.dispatch('clearCurrentPricingRequest')
            store.dispatch('clearAllFacilityData')
            router.push({ name: 'PricingTable'})
          }

          store.commit('SET_SAVED_PRICING_REQUEST_ID', response.data.id)

          if (issueImmediately) {
            store.dispatch('getPricing', response.data.id)
          }
        })
        .catch(error => {
          store.dispatch('setNotification', {
            type: 'error',
            msg: error.response.data || 'An unexpected error occurred.'
          })
        })
    }
  }
}

/* Save Pricing Request */
export const updatesavedPricingRequest = async function(store, skipRedirect) {

  const utility = store.state.currentPricingRequest.utilityMeta
  const utilityPlanData = store.state.currentPricingRequest.utility
  
  // Free-Registered Plan users can only have one set of saved 
  // user inputs, so either update the current set or create a new set.
  if (utilityPlanData.plan.slug === 'free-registered') {

    // Get all unsubscribed/free-registered user inputs.
    // NOTE: savedPricingRequests are actually saved user inputs (on the backend), not data requests.
    const unsubscribedPricingRequestIds = store.getters.savedPricingRequestIds.unsubscribed
    let matched = false

    // Loop through them to update the current set of user inputs,
    // and deleting any additional sets.
    for (let i = 0; i < unsubscribedPricingRequestIds.length; ++i) { 

      // Match found, so let's update it.
      if (store.state.currentPricingRequest.savedPricingRequestId === unsubscribedPricingRequestIds[i]) {
        matched = true
        updatePricingRequest(store, skipRedirect)

      // Non-match, so delete it.
      } else {
        axios.delete('/pricing-calculator/me/inputs/' + unsubscribedPricingRequestIds[i])
      }
    }

    // No match found so create a new set of user inputs.
    if (!matched) {
      setTimeout(async () => {

        // Clear saved price requests (user inputs)
        store.commit('DELETE_SAVED_PRICING_REQUESTS')

        // Reload authenticated user's info so that their saved price request ids (user input ids)
        // are refreshed.
        await store.dispatch('setUser')

        store.dispatch('savecurrentPricingRequest', skipRedirect)
      }, 500)
    }

  // ... all other plan users.
  } else {
    updatePricingRequest(store, skipRedirect)
  }
  
  function updatePricingRequest(store, skipRedirect) {
    // Copy the existing pricing request
    let pricingRequest = cloneDeep(store.state.currentPricingRequest)
  
    // Convert Start Date Format
    if (pricingRequest.startMonth) {
      pricingRequest.startMonth = moment(pricingRequest.startMonth).format('YYYY-MM-DD')
    }

    // Transform terms array
    if (pricingRequest.termLength) {
      pricingRequest.termLength = pricingRequest.termLength.filter(t => t.value != '').map(t => ({ term: t.value }))
    }

    if (pricingRequest.customFacilityProfile.total && pricingRequest.customFacilityProfile.total.usage) {
      pricingRequest.volume.amount = pricingRequest.customFacilityProfile.total.usage
    }

    // Determine facility type name
    pricingRequest.facilityTypeName = ''

    // Trace parent facility type name from ancestor options
    if (pricingRequest.facilityType.parents) {
      let facilityProfileId = pricingRequest.facilityType.id
      
      if (pricingRequest.facilityType.parents.length > 1) {
        facilityProfileId = pricingRequest.facilityType.parents[pricingRequest.facilityType.parents.length - 2]
      }

      // Get a specific facility profile with utility-specific information.
      axios.get('/pricing-calculator/facility-profiles/' + pricingRequest.utilityMeta.id + '/profile/' + facilityProfileId)
        .then(response => {
          pricingRequest.facilityTypeName = response.data.name

          // Save a new set of user inputs.
          axios.put('/pricing-calculator/me/inputs/' + pricingRequest.savedPricingRequestId, pricingRequest)
            .then(userInputsResponse => {
              store.dispatch('setDashboardSortUtility', pricingRequest.utilityMeta)
              localStorage.setItem('epb_utility_sort', JSON.stringify(pricingRequest.utilityMeta))
              localStorage.setItem('epb_uid', store.state.auth.user.id)
              
              if (!skipRedirect) {
                router.push({ name: 'PricingTable'})
              }
            })
        })
    } else {
      if (pricingRequest.customFacilityProfileCategory.tier2 && pricingRequest.customFacilityProfileCategory.tier2.name) {
        pricingRequest.facilityTypeName = 'Custom: ' + pricingRequest.customFacilityProfileCategory.tier2.name
      }

      // Save a new set of user inputs.
      axios.put('/pricing-calculator/me/inputs/' + pricingRequest.savedPricingRequestId, pricingRequest)
        .then(userInputsResponse => {
          store.dispatch('setDashboardSortUtility', pricingRequest.utilityMeta)
          localStorage.setItem('epb_utility_sort', JSON.stringify(pricingRequest.utilityMeta))
          localStorage.setItem('epb_uid', store.state.auth.user.id)
          
          if (!skipRedirect) {
            router.push({ name: 'PricingTable'})
          }
        })
    }
  }
}

/* Fetch Saved Pricing Requests */
export const fetchSavedPricingRequests = async function(store) {
  store.commit('SET_IS_LOADING_SAVED_PRICE_REQUESTS', true)

  let utilityId = store.getters.dashboardSortUtility.id

  console.log('Fetching for utility ' + utilityId)

  if (! utilityId) {
    if (store.getters.userUtilities[0]) {
      utilityId = store.getters.userUtilities[0].id

      store.dispatch('setDashboardSortUtility', store.getters.userUtilities[0])
    }
  }

  if (! utilityId) {
    return
  }

  // Make sure that this utility ID is still the selected one.
  if (utilityId != store.getters.dashboardSortUtility.id) {
    console.log(`Canceling loading saved pricing requests for ID ${utilityId}...`)
    return
  }

  console.log(`Loading saved pricing requests for ID ${utilityId}...`)

  // Load...
  const resp = await axios.get('/pricing-calculator/me/inputs/' + utilityId)

  store.commit('REPLACE_SAVED_PRICING_REQUESTS', resp.data)
  store.commit('SET_IS_LOADING_SAVED_PRICE_REQUESTS', false)

  console.log(`Saved pricing request loading complete for ID ${utilityId}`)
}

/* Load a price request by its uiid (user_inputs_id) */
export const loadPriceRequestByUiid = async function(store, uiid) {
  store.commit('SET_IS_LOADING_SAVED_PRICE_REQUESTS', true)

  // First we need to load the request so that we can get its utility.
  const resp = await axios.get('/pricing-calculator/me/data/requests', {
    params: {
      user_input_id: uiid
    }
  })

  // The the current utility.
  const priceRequest = resp.data[0]
  const utilityId = priceRequest.utility_id
  const utility = store.getters.userUtilities.find(u => u.id == utilityId)

  await store.dispatch('setDashboardSortUtility', utility)

  // Now we load all the requests from that utility.
  await store.dispatch('fetchSavedPricingRequests')

  // Finally, we load the requested price request.
  await store.dispatch('loadSavedPricingRequest', {
    id: parseInt(uiid),
    viaUrl: true,
  })

  store.commit('SET_IS_LOADING_SAVED_PRICE_REQUESTS', false)
}

/* Clear Saved Pricing Requests */
export const clearSavedPricingRequests = function({ commit }) {
  commit('DELETE_SAVED_PRICING_REQUESTS')
}

/* Reorder Saved Pricing Requests */
export const reordersavedPricingRequests = function(store, data) {
  const newOrder = {
    ids: data.ids,
    utilityId: data.utilityId,
  }

  axios.post('/pricing-calculator/me/inputs/order', newOrder)
    .then(response => {
      store.dispatch('fetchSavedPricingRequests')
    })
}

/* Update Saved Pricing Request Name */
export const updatePricingRequestName = function(store, obj) {
  let pricingRequest = store.state.savedPricingRequests.filter(pricingRequest => pricingRequest.id === obj.id)
  let pricingRequestInputs = cloneDeep(pricingRequest[0].inputs)

  pricingRequestInputs.facilityProfileName = obj.name

  axios.put('/pricing-calculator/me/inputs/' + obj.id + '/metadata', { facilityProfileName: pricingRequestInputs.facilityProfileName })
    .then(response => {
      store.dispatch('fetchSavedPricingRequests')
    })
}

/* Update Saved Pricing Request Notes */
export const savePricingRequestNotes = async function (store, obj) {
  const resp = await axios.put(`/pricing-calculator/me/inputs/${obj.id}/notes`, {
    adjustmentNotes: obj.adjustmentNotes,
    notes: obj.notes,
  })

  store.dispatch('fetchSavedPricingRequests')
}

/* Update Saved Pricing Request Primary Component */
export const updatePricingRequestPrimaryComponent = function(store, obj) {
  let pricingRequest = store.state.savedPricingRequests.filter(pricingRequest => pricingRequest.id === obj.id)
  let pricingRequestInputs = cloneDeep(pricingRequest[0].inputs)

  pricingRequestInputs.primaryPricingComponent = obj.primaryPricingComponent
  pricingRequestInputs.existingSupplyPrice = obj.existingSupplyPrice

  axios.put('/pricing-calculator/me/inputs/' + obj.id + '/metadata', { 
    primaryPricingComponent: pricingRequestInputs.primaryPricingComponent,
    existingSupplyPrice: pricingRequestInputs.existingSupplyPrice,
  })
}

/* Update Saved Price Request's Alerts Config */
export const updatePricingRequestAlertsConfig = function(store, obj) {
  let pricingRequest = store.state.savedPricingRequests.filter(pricingRequest => pricingRequest.id === obj.id)
  let pricingRequestInputs = cloneDeep(pricingRequest[0].inputs)

  pricingRequestInputs.existingSupplyPrice = obj.existingSupplyPrice

  // Return the promise...
  return axios.put('/pricing-calculator/me/inputs/' + obj.id + '/metadata', { 
    additionalAlertRecipients: obj?.additionalRecipients,
    existingSupplyPrice: pricingRequestInputs.existingSupplyPrice,
  })
}

/* Load Saved Pricing Request */
export const loadSavedPricingRequest = async function(store, obj) {

  let pricingRequest = store.state.savedPricingRequests.filter(pricingRequest => pricingRequest.id === obj.id)

  // The data request's "user inputs".
  let pricingRequestInputs = cloneDeep(pricingRequest[0].inputs)
  pricingRequestInputs.savedPricingRequestId = obj.id

  // Transform tier2 to new format, which contains sub-selections.
  // For example:

  // Old format: 
  // tier2: {
  //   id: 3,
  //   name: "Professional Building: 3 to 11 Stories",
  // }

  // New format:
  // tier2: {
  //   facilityCheckboxOptions: [],
  //   facilityType: {
  //     id: 3,
  //     name: "Professional Building: 3 to 11 Stories",
  //   }
  // }

  if (
    pricingRequestInputs.customFacilityProfileCategory.tier2 && 
    pricingRequestInputs.customFacilityProfileCategory.tier2.id
  ) {
    pricingRequestInputs.customFacilityProfileCategory.tier2 = {
      facilityCheckboxOptions: [], // Old format doesn't have this data, so we don't need to worry about it.
      facilityType: pricingRequestInputs.customFacilityProfileCategory.tier2
    }
  }

  // Default value if undefined.
  if (pricingRequestInputs.enterCustomFacilityProfileOnPeakUsageAsPercentage === undefined) {
    pricingRequestInputs.enterCustomFacilityProfileOnPeakUsageAsPercentage = false
  }

  // Set the start month to a moment.js instance.
  if (pricingRequestInputs.startMonth) {
    pricingRequestInputs.startMonth = moment(pricingRequestInputs.startMonth)
  }

  let termLength = [
    {
      id: 1,
      value: ''
    },
    {
      id: 2,
      value: ''
    },
    {
      id: 3,
      value: ''
    }
  ]

  if (pricingRequestInputs.termLength) {
    for (let i = 0; i < pricingRequestInputs.termLength.length; ++i) {
      termLength[i].value = pricingRequestInputs.termLength[i].term
    }
  }

  pricingRequestInputs.termLength = termLength

  // Save comparison copy to determine if changes are made
  const copyA = cloneDeep(pricingRequestInputs)
  const copyB = cloneDeep(pricingRequestInputs)

  // The below actually save the data request's "user inputs".
  store.commit('LOAD_SAVED_PRICING_REQUEST', copyA)
  store.commit('SAVE_LOADED_PRICING_REQUEST', copyB)
  store.commit('CLEAR_FACILITY_CATEGORY')

  store.dispatch('unsetCustomFacilityProfileView')

  if (pricingRequestInputs.customFacilityProfile.months && pricingRequestInputs.customFacilityProfile.months.length > 0)   {
    store.dispatch('setCustomFacilityProfileView')
  }
  
  store.dispatch('fetchFacilityProfiles', pricingRequestInputs.utility.id)

  store.commit('SET_PRICING_REQUEST_STATUS', '')
  store.commit('RESET_STATE_BROKER_FEE')

  if (pricingRequestInputs.volume.declineBrokerFee) {
    store.commit('DECLINE_BROKER_FEE') 
  } 

  // Get top-level pricing component data, grouped by term length, by a user input ID.
  // Return the promise...
  return axios.get('/pricing-calculator/me/data/inputs/' + obj.id)
    .then(response => {
      store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
      store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
      store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
      store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')

      let startDate
      let firstTerm = response.data.request.parameters.terms[0].term
      let termData = response.data.data[firstTerm] || {}
      let chartComponentData = []

      for (let [key, value] of Object.entries(termData)) {
        let componentData = []

        for (var i = 0; i < 1; i++) {
          startDate = moment(termData[key][0].date).format('M/DD/YYYY')
        }

        componentData = termData[key].filter(item => moment(item.date).format('M/DD/YYYY') === startDate)
        
        if (componentData.length) {
          chartComponentData.push(componentData[0])
        }  
      }

      if (chartComponentData.length) {
        store.dispatch('setCurrentPricingChartData', chartComponentData)
      }

      router.push({ name: 'PricingData' })
    })
    .catch(error => {
      store.commit('CLEAR_PRICING_REQUEST_STATUS')
      store.commit('CLEAR_CURRENT_PRICING_CHART_DATA')
      store.commit('CLEAR_CURRENT_PRICING_DATA')

      if (obj.viaUrl) {
        let generateData = validRequest(store)

        if (generateData) {
          store.dispatch('getPricing', obj.id)
          router.push({ name: 'PricingData'})
        } else {
          router.push({ name: 'GetPricing' })
        }
      } else {
        router.push({ name: 'GetPricing' })
      }
    })

  function validRequest(store) {
    
    if (!store.state.auth.user.id || store.state.auth.plan.slug === 'free') {
      return false
    }

    let startMonth

    if (store.state.currentPricingRequest.startMonth) {
      startMonth = moment(store.state.currentPricingRequest.startMonth).format('MMM YYYY')
    }

    if (startMonth !== null) {
      if (moment(startMonth).isBefore()) {
        return false
      }
    } else {
      return false
    }

    let isCustomFacilityProfile = false
    let count = Object.keys(store.state.currentPricingRequest.customFacilityProfile).length

    if (count > 0) {
      isCustomFacilityProfile = true
    }

    let customFacilityVolume

    if (store.state.currentPricingRequest.customFacilityVolume.terms && store.state.currentPricingRequest.customFacilityVolume.terms.length) {
      customFacilityVolume = store.state.currentPricingRequest.customFacilityVolume
    } else {
      customFacilityVolume = false
    }

    if (isCustomFacilityProfile && !store.getters.customFacilityProfileComplete) {
      return false
    }

    if (isCustomFacilityProfile && !customFacilityVolume) {
      return false
    }

    if (!store.state.currentPricingRequest.utilityMeta.name || !store.state.currentPricingRequest.utilityMeta.code) {
      return false
    }

    if (store.state.currentPricingRequest.termLength.length < 1) {
      return false
    }

    if (!store.state.currentPricingRequest.volume.amount) {
      return false
    }

    if (!store.getters.declineBrokerFee && !store.state.currentPricingRequest.volume.brokerFee) {
      return false
    }

    return true
  }
}

/* Submit Pricing Request / Get Pricing */
export const getPricing = function(store, inputId) {

  // Update last loaded request (to watch for changes to current inputs)
  let requestCopy = cloneDeep(store.state.currentPricingRequest)
  store.commit('SAVE_LOADED_PRICING_REQUEST', requestCopy)

  store.dispatch('clearCurrentPricingChartData')

  let facilityProfileId,
      facilityProfileOptions,
      brokerFee,
      isCustom = false;

  // Non-custom facility profiles:
  if (store.state.currentPricingRequest.facilityType.id) {

    facilityProfileId = store.state.currentPricingRequest.facilityType.category

    let facilityType = cloneDeep(store.state.currentPricingRequest.facilityType)
    let facilityCheckboxSelections = []

    if (store.state.currentPricingRequest.facilityCheckboxSelections) {
      facilityCheckboxSelections = cloneDeep(store.state.currentPricingRequest.facilityCheckboxSelections)

      facilityProfileOptions = prepareFacilityOptions(facilityType, facilityCheckboxSelections)
    
    } else {
      facilityProfileOptions = prepareFacilityOptions(facilityType)
    }
  } else {
    isCustom = true
  }
  
  // Broker Fee:
  if (store.state.currentPricingRequest.volume.brokerFee) {
    brokerFee = parseFloat(store.state.currentPricingRequest.volume.brokerFee)
  }

  // Volume:
  let usage = 0

  if (store.state.currentPricingRequest.volume.amount) {
    usage = (store.state.currentPricingRequest.volume.amount * 1)
  
  } else if (store.state.currentPricingRequest.customFacilityVolume.terms && store.state.currentPricingRequest.customFacilityVolume.terms.length) {
    
    for (let i = 0; i < store.state.currentPricingRequest.customFacilityVolume.terms.length; ++i) {

      if (store.state.currentPricingRequest.customFacilityVolume.terms[i].usage > usage ) {
        usage = store.state.currentPricingRequest.customFacilityVolume.terms[i].usage
      }
    }
  }

  // Prepare Custom Profile Data:
  let customProfileReq = {}

  if (isCustom && Object.keys(store.state.currentPricingRequest.customFacilityProfile).length) {
    
    let customProfile = cloneDeep(store.state.currentPricingRequest.customFacilityProfile)

    customProfileReq['MU'] = {}
    customProfileReq['MPD'] = {}
    customProfileReq['OFMU'] = {}
    customProfileReq['PKMU'] = {}
    customProfileReq['custom'] = {}

    if (customProfile.months.length) {
      for (let i = 0; i < customProfile.months.length; ++i) {

        let month = moment(customProfile.months[i].month).format('YYYY-MM-DD')

        customProfileReq['MU'][month] = customProfile.months[i].usage.toString()
        customProfileReq['MPD'][month] = customProfile.months[i].peakDemand.toString()
        customProfileReq['OFMU'][month] = customProfile.months[i].offPeakUsage.toString()
        customProfileReq['PKMU'][month] = customProfile.months[i].onPeakUsage.toString()
      }
    }

    if (customProfile.extraColumns.length) {
      for (let x = 0; x < customProfile.extraColumns.length; ++x) {
        customProfileReq['custom'][customProfile.extraColumns[x].id] = {}

        for (let y = 0; y < customProfile.extraColumns[x].months.length; ++y) {
          let month = moment(customProfile.extraColumns[x].months[y].month).format('YYYY-MM-DD')

          customProfileReq['custom'][customProfile.extraColumns[x].id][month] = customProfile.extraColumns[x].months[y].value.toString()
        }
      }
    }
  } 

  let userInputId = store.state.currentPricingRequest.savedPricingRequestId

  if (inputId) {
    userInputId = inputId
  }

  let startMonth = moment.isMoment(store.state.currentPricingRequest.startMonth) 
    ? store.state.currentPricingRequest.startMonth._i
    : store.state.currentPricingRequest.startMonth;

  const obj = {
    utility_id: store.state.currentPricingRequest.utilityMeta.id,
    user_input_id: userInputId,
    zip: store.state.currentPricingRequest.utilityMeta.code,
    date_start: startMonth,
    terms: store.state.currentPricingRequest.termLength.filter(t => t.value != '').map(t => ({ term: t.value })), // ex: [ {term: 12}, {term: 24}, {term: 36} ]
    facility_profile_id: facilityProfileId,
    facility_profile_options: facilityProfileOptions,
    volume: usage,
    volume_type: store.state.currentPricingRequest.volume.unit,
    facility_profile_label: store.state.currentPricingRequest.facilityProfileName, // User-defined profile name [ string ]
    broker_fee: brokerFee, // Broker Fee [ number ]
  };

  if (isCustom) {
    obj.facility_profile_id = 'custom'
    obj.custom_profile = customProfileReq
    obj.broker_fee = store.state.currentPricingRequest.customFacilityVolume.brokerFee
    delete obj.facility_profile_options
  }

  // Load data using the user data request id
  function loadData(id, store) {
    axios.get('/pricing-calculator/utilities/data', { params: {id: id} })
      .then(response => {
        store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')

        let data = JSON.parse(response.data.data)

        store.commit('SET_CURRENT_PRICING_DATA', data)
      })
  }

  store.commit('SET_PRICING_REQUEST_STATUS', 'Pending')

  // Submit a request to generate data
  axios.post('/pricing-calculator/data/requests', obj)
    .then(response => {

      store.commit('SET_PRICING_REQUEST_STATUS', 'DataStarted')
      store.dispatch('setCurrentBatch', 1)

      let userIsLoggedIn = false
      let utilityPlan = store.state.currentPricingRequest.utility.plan

      if (
        store.state.auth && 
        store.state.auth.user &&
        store.state.auth.user.id
      ) {
        userIsLoggedIn = true
      }

      router.push({ name: 'PricingData' })

      let eventDataCompleted = false

      // User is authenticated, so use a private channel
      if (userIsLoggedIn) {

        // Stop active listeners
        for (let i = 0; i < Object.keys(store.state.activeListeners).length; ++i) {
          window.Echo.leave(`userdata.${store.state.auth.user.id}.${store.state.activeListeners[i]}`)

          store.dispatch('removeActiveListener', store.state.activeListeners[i])
        }

        store.dispatch('addActiveListener', response.data.id)

        // Reload the authenticated user's info so that 
        // `stores.state.userInputUtilities` is updated.
        store.dispatch('setUser') 

        // User is logged-in, so we listen on the user's private channel
        // using their user ID
        window.Echo.private(`userdata.${store.state.auth.user.id}.${response.data.id}`)
          .listen('DataStarted', (e) => {
            //console.log('DataStarted', e)
            store.commit('SET_PRICING_REQUEST_STATUS', 'DataStarted')
            store.dispatch('setCurrentBatch', 1)
          })
          .listen('DataBatchDateCompleted', (e) => {
            store.dispatch('setBatchDatesRemaining', e.date.remaining_dates)
            store.dispatch('setBatchDatesTotal', e.date.total_dates)

            if (
              e.date.remaining_dates === 0 && 
              e.batch.batch === 2 && 
              ! ['basic', 'premium', 'premium-legacy-1'].includes(utilityPlan.slug)
            ) {
              if (!eventDataCompleted) {
                eventDataCompleted = true
                //console.log('DataCompleted', e)
                store.commit('SET_PRICING_REQUEST_STATUS', 'DataCompleted')
              }

              store.dispatch('clearBatchDates')
              store.dispatch('removeActiveListener', response.data.id)

              window.Echo.leave(`userdata.${store.state.auth.user.id}.${response.data.id}`)

              axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
                .then(function(response) {
                  store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                  store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                  store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                  store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')
                })
            }
          })
          .listen('DataBatchCompleted', (e) => {
            // console.log('DataBatchCompleted', e)
            store.commit('SET_PRICING_REQUEST_STATUS', 'DataBatchCompleted')
            //console.log('Batch #' + e.batch.batch + ' has finished processing.')
            store.commit('SET_PRICING_REQUEST_STATUS', 'Batch #' + e.batch.batch + ' has finished processing.')
            store.dispatch('clearBatchDates')
            store.dispatch('setCurrentBatch', e.batch.batch + 1)

            axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
              .then(function(response) {
                store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                //store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')
              })

            if (
              e.batch.batch === 2 || 
              e.batch.batch === 1 && 
              ! ['basic', 'premium', 'premium-legacy-1'].includes(utilityPlan.slug)
            ) {
              if (!eventDataCompleted) {
                eventDataCompleted = true
                //console.log('DataCompleted', e)
                store.commit('SET_PRICING_REQUEST_STATUS', 'DataCompleted')
              }

              store.dispatch('clearBatchDates')
              store.dispatch('removeActiveListener', response.data.id)

              window.Echo.leave(`userdata.${store.state.auth.user.id}.${response.data.id}`)

              axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
                .then(function(response) {
                  store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                  store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                  store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                  store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded') // maybe

                  // Reload all saved pricing requests.
                  store.dispatch('fetchSavedPricingRequests')
                })
            }

          })
          .listen('DataCompleted', (e) => {

            if (!eventDataCompleted) {
              eventDataCompleted = true
              //console.log('DataCompleted', e)
              store.commit('SET_PRICING_REQUEST_STATUS', 'DataCompleted')
            }

            store.dispatch('clearBatchDates')
            store.dispatch('removeActiveListener', response.data.id)

            window.Echo.leave(`userdata.${store.state.auth.user.id}.${response.data.id}`)

            axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
              .then(function(response) {
                store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')

                // Reload all saved pricing requests.
                store.dispatch('fetchSavedPricingRequests')
              })
          });

      } else {

        // If not logged-in, we listen on a public channel
        // using the data request ID
        window.Echo.channel(`data.${response.data.id}`)
          .listen('DataStarted', (e) => {
            store.commit('SET_PRICING_REQUEST_STATUS', 'DataStarted')
            store.dispatch('setCurrentBatch', 1)
          })
          .listen('DataBatchDateCompleted', (e) => {
            store.dispatch('setBatchDatesRemaining', e.date.remaining_dates)
            store.dispatch('setBatchDatesTotal', e.date.total_dates)

            if (e.date.remaining_dates === 0 && e.batch.batch === 2) {
              if (!eventDataCompleted) {
                eventDataCompleted = true
                //console.log('DataCompleted', e)
                store.commit('SET_PRICING_REQUEST_STATUS', 'DataCompleted')
              }

              store.dispatch('clearBatchDates')
              store.dispatch('removeActiveListener', response.data.id)

              window.Echo.leave(`data.${response.data.id}`)

              axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
                .then(function(response) {
                  store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                  store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                  store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                  store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')
                })
            }
          })
          .listen('DataBatchCompleted', (e) => {
            //console.log('DataBatchCompleted', e)
            store.commit('SET_PRICING_REQUEST_STATUS', 'DataBatchCompleted')
            //console.log('Batch #' + e.batch.batch + ' has finished processing.')
            store.commit('SET_PRICING_REQUEST_STATUS', 'Batch #' + e.batch.batch + ' has finished processing.')
            store.dispatch('clearBatchDates')
            store.dispatch('setCurrentBatch', e.batch.batch + 1)

            axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
              .then(function(response) {
                store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                //store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')
              })

            if (e.batch.batch === 2 || e.batch.batch === 1) {
              if (!eventDataCompleted) {
                eventDataCompleted = true
                //console.log('DataCompleted', e)
                store.commit('SET_PRICING_REQUEST_STATUS', 'DataCompleted')
              }

              store.dispatch('clearBatchDates')
              store.dispatch('removeActiveListener', response.data.id)

              window.Echo.leave(`data.${response.data.id}`)

              axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
                .then(function(response) {
                  store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                  store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                  store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                  store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded') // maybe
                })
            }
          })
          .listen('DataCompleted', (e) => {
            if (!eventDataCompleted) {
              eventDataCompleted = true
              //console.log('DataCompleted', e)
              store.commit('SET_PRICING_REQUEST_STATUS', 'DataCompleted')
            }

            store.dispatch('clearBatchDates')
            store.dispatch('removeActiveListener', response.data.id)

            window.Echo.leave(`data.${response.data.id}`)

            console.log(`Loading completed data request ${response.data.id}...`)

            axios.get('/pricing-calculator/data/requests/' + e.data_request.id)
              .then(function(response) {
                store.commit('SET_CURRENT_PRICING_DATA', response.data.data)
                store.commit('SET_CURRENT_PRICING_DATA_TOTALS', response.data.totals)
                store.commit('SET_CURRENT_PRICING_DATA_REQUEST_ID', response.data.request.id)
                store.commit('SET_PRICING_REQUEST_STATUS', 'Loaded')
              })
          });
      }
    })
}

/* Clear Current Pricing Data */
export const clearCurrentPricingData = function({ commit }, obj) {
  commit('CLEAR_CURRENT_PRICING_DATA')
}

/* Set Current Pricing Chart Data */
export const setCurrentPricingChartData = function({ commit }, obj) {
  commit('SET_CURRENT_PRICING_CHART_DATA', obj)
}

/* Clear Current Pricing Chart Data */
export const clearCurrentPricingChartData = function({ commit }) {
  commit('CLEAR_CURRENT_PRICING_CHART_DATA')
}

/* Set Current Pricing Chart Locked Date */
export const setCurrentPricingChartLockedDate = function({ commit }, date) {
  commit('SET_CURRENT_PRICING_CHART_LOCKED_DATE', date)
}

/* Clear Pricing Request Status */
export const clearPricingRequestStatus = function({ commit }) {
  commit('CLEAR_PRICING_REQUEST_STATUS')
}

/* Set Pricing Request Status */
export const setPricingRequestStatus = function(store, string) {
  store.commit('SET_PRICING_REQUEST_STATUS', string)
}

/* Clear All Output Data */
export const clearAllOutputData = function(store) {
  store.commit('CLEAR_PRICING_REQUEST_STATUS')
  store.commit('CLEAR_CURRENT_PRICING_CHART_DATA')
  store.commit('CLEAR_CURRENT_PRICING_DATA')

  let userIsLoggedIn = false;

  if (store.state.auth.user.id && store.state.auth.plan.slug != 'free') {
    userIsLoggedIn = true;
  }
}

/* Set Dashboard Sort Utility */
export const setDashboardSortUtility = async function(store, obj) {

  // Check plan level utility is subscribed at
  const response = await axios.get('/pricing-calculator/me/utilities/' + obj.id + '/get-plan')

  // Create a clone so that we're not mutating the Vuex `obj` 
  // outside of a mutator function.
  let newObj = cloneDeep(obj)

  newObj.plan = {
    name: response.data.name,
    slug: response.data.slug,
  }
  store.commit('SET_DASHBOARD_SORT_UTILITY', newObj)

  // Load the user's inputs for the sort utility
  if (!obj.doNotFetchSavedPricingRequest) {
    store.dispatch('fetchSavedPricingRequests')
  }

  // Set Dashboard Pricing Components
  await store.dispatch('setDashboardPricingComponents', obj.id)

  store.commit('COLLAPSE_PRICING_TABLE_ROWS')
}

// Set Dashboard Pricing Components
export const setDashboardPricingComponents = async function(store, utilityId) {
  const response = await axios.get('/pricing-calculator/utilities/' + utilityId + '/pricing-components')

  store.commit('SET_DASHBOARD_PRICING_COMPONENTS', response.data)
}

/* Delete a Set of Config Inputs */
export const deleteInputSet = function(store, id) {
  axios.delete('/pricing-calculator/me/inputs/' + id)
    .then(response => {
      store.dispatch('fetchSavedPricingRequests')

      if (store.state.currentPricingRequest.savedPricingRequestId === id) {
        store.commit('CLEAR_CURRENT_PRICING_REQUEST')
        store.commit('CLEAR_CURRENT_PRICING_CHART_DATA')
        store.dispatch('clearAllFacilityData')
      }
    })
}

/* Toggle Pricing Table Row Expansion */
export const toggleExpandPricingTableRows = function({ commit }) {
  commit('TOGGLE_EXPAND_PRICING_TABLE_ROWS')
}

/* Toggle Pricing Table Row Expansion */
export const expandPricingTableRows = function({ commit }) {
  commit('EXPAND_PRICING_TABLE_ROWS')
}

/* Toggle Pricing Table Row Expansion */
export const collapsePricingTableRows = function({ commit }) {
  commit('COLLAPSE_PRICING_TABLE_ROWS')
}

/* Set Total Batch Dates */
export const setBatchDatesTotal = function({ commit }, count) {
  commit('SET_TOTAL_BATCH_DATES', count)
}

/* Set Remaining Batch Dates */
export const setBatchDatesRemaining = function({ commit }, count) {
  commit('SET_REMAINING_BATCH_DATES', count)
}

/* Clear Batch Dates */
export const clearBatchDates = function({ commit }) {
  commit('CLEAR_BATCH_DATES')
}

/* Set Current Batch */
export const setCurrentBatch = function({ commit }, batch) {
  commit('SET_CURRENT_BATCH', batch)
}

/* Add Data Listener */
export const addActiveListener = function({ commit }, id) {
  commit('ADD_DATA_LISTENER', id)
}

/* Remove Data Listener */
export const removeActiveListener = function({ commit }, id) {
  commit('REMOVE_DATA_LISTENER', id)
}

/* Clear Data Listeners */
export const clearActiveListeners = function({ commit }) {
  commit('CLEAR_DATA_LISTENERS')
}

/* Set Screen/View Capture */
export const setViewCapture = function({ commit }, canvas) {
  commit('SET_VIEW_CAPTURE', canvas)
}

/* Add to the stored user share emails */
export const addToUserShareEmails = function(store, emails) {
  if (emails) {
    store.commit('ADD_TO_USER_SHARE_EMAILS', emails)
  }
}

/* Remove a stored user share email */
export const removeFromUserShareEmails = function(store, email) {
  store.commit('REMOVE_FROM_USER_SHARE_EMAILS', email)
  if (store.state.auth.user.id) {
    axios.delete('/pricing-calculator/share', {body: {email: email}})
  }
}

/* Accept Terms of Use */
export const acceptTermsOfUse = function({ commit }) {
  commit('ACCEPT_TERMS_OF_USE')
}

/* Decline Terms of Use */
export const declineTermsOfUse = function({ commit }) {
  commit('DECLINE_TERMS_OF_USE')
}
